import { render, staticRenderFns } from "./field-no-action-required-settings.vue?vue&type=template&id=3733ac4b&"
import script from "./field-no-action-required-settings.vue?vue&type=script&lang=js&"
export * from "./field-no-action-required-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports